module.exports = __webpack_public_path__ + "img/piggy-bank-02.3375cfdf.svg";